export * from "../cli/common.ts";
export async function run(cmd, args) {
    void cmd, args;
    throw new Error("Unsupported runtime");
}
export async function powershell(script) {
    void script;
    throw new Error("Unsupported runtime");
}
export async function sudo(cmd, args, options = {}) {
    void cmd, args, options;
    throw new Error("Unsupported runtime");
}
export async function which(cmd) {
    void cmd;
    throw new Error("Unsupported runtime");
}
export async function edit(filename) {
    void filename;
    throw new Error("Unsupported runtime");
}
//# sourceMappingURL=cli.js.map